export default {
  label: "Device Verwaltung",
  tabs: {
    devices: {
      label: "Geräte",
      deviceList: "Geräteliste",
      noActiveDevicesMessage: "Keine aktiven Geräte verfügbar",
      activateDeviceButtonLabel: "Gerät aktivieren",
      createFirstDevice: "Aktivieren Sie Ihr erstes Gerät",
      createDeviceHelperText:
        "Geräte, die Sie aktivieren, werden hier mit ihrem Status, Modell und ihrer Bereitstellungsgruppe angezeigt",
      activateDevice: {
        label: "Gerät aktivieren",
        activateYourDevice: "Aktivieren Sie Ihr Gerät",
        deviceToken: "Gerätetoken",
        enterTokenMessage:
          "Geben Sie das auf Ihrem Gerät angezeigte Anspruchstoken ein, um es mit Ihrem Konto zu verknüpfen.",
        singleUseMessage: "Das Token ist einmalig verwendbar und läuft nach kurzer Zeit ab.",
        tokenNotWorkingMessage:
          "Wenn es nicht funktioniert, starten Sie Ihr Gerät neu, um ein neues Token zu generieren.",
        afterSubmittingTokenMessage:
          "After submitting the token, your device will be assigned to your account and complete its setup automatically.",
      },
      newDevice: "Neues Gerät",
      editDevice: "Gerät bearbeiten",
      removeButton: "Entfernen",
      tags: "Tags",
      configuration: "Configuration",
      update: "Update",
      assignments: "Assignments",
      makeAssignment: "Make Assignment",
      unassign: "unassign",
      logs: "logs",
      device: "Device",
      noAsset: "Kein Asset zugewiesen",
      noDevice: "Keine Geräte-Zuordnung",
      deviceName: "Gerätename",
      preRegisteredDevice: {
        title: "Gerätedetails können nicht angezeigt werden",
        message:
          "Dieses Gerät ist noch nicht aktiv.\n\nSie können die Gerätedetails erst anzeigen, nachdem es aktiviert wurde.",
      },
      noDevicesCreatedYet: "Noch Keine Geräte Erstellt",
      columns: {
        deviceName: "Gerätename",
      },
    },
    deleteDevices: {
      label: "Geräte löschen",
      message:
        "Sind Sie sicher, dass Sie das/die ausgewählten Gerät(e) löschen möchten? Dies kann nicht rückgängig gemacht werden.",
      devicesNotDeletedLabel: "Gerät(e) konnten nicht gelöscht werden",
      devicesWithParentMessage:
        "Die folgenden Geräte konnten aufgrund vorhandener Eltern geräte nicht gelöscht werden:",
      errorDeleteDevicesMessage:
        "Beim Versuch, die ausgewählten Geräte zu löschen, ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    },
    deviceGroups: {
      label: "Device Gruppen",
      list: "Device List",
      activities: "Activities",
      newDeviceGroup: "Neue Device Gruppe",
    },
    deviceTypes: {
      label: "Device Typen",
      labelWithCount: "Device Typen ({count})",
      addButton: "Add Model",
      editModel: "Edit",
      deleteModel: "Delete",
      createDeviceType: "Device-Typ erstellen",
      newDeviceType: "Neuer Device Type",
      createFirstDeviceType: "Erstellen Sie Ihren ersten Device-Typ",
      noDeviceTypesCreatedYet: "Es wurden noch keine Device Typen erstellt",
      contactAdminToCreate: "Bitte wenden Sie sich an Ihren Administrator, um Device Typen zu erstellen",
      tabs: {
        models: {
          label: "Modelle",
          noDeviceModelsCreatedYet: "Es wurden noch keine Device Modelle erstellt",
        },
      },
    },
    sharedModels: {
      label: "Geteilte Gerätemodelle",
      addDeviceModel: "Gerätemodell hinzufügen",
      addAndShare: "Hinzufügen und teilen",
      noDeviceTypesMessage: "Keine verfügbaren Gerätetypen",
      noDeviceModelsMessage: "Keine verfügbaren Gerätemodelle",
      showShareDeviceModelDetails: "Gerätemodell-Details anzeigen",
      hideShareDeviceModelDetails: "Gerätemodell-Details ausblenden",
      appsAffectedBySharingMessage: "Die folgenden {count} Apps werden dadurch geteilt:",
      shareModelWarningMessage:
        "Dies wird das ausgewählte Gerätemodell mit allen Mandanten teilen.\nEinmal hinzugefügt, kann es nicht aus dieser Liste entfernt werden und bleibt allen Mandanten verfügbar.",
      sharedModelsHeaderMessage:
        "Die hier aufgeführten Gerätemodelle werden mit allen Mandanten geteilt. Das Hinzufügen eines Modells zu dieser Liste macht es für alle Mandanten verfügbar und markiert es in deren Ansicht als geteilt.",
      actionPermanentMessage: "Diese Aktion ist dauerhaft und kann nicht rückgängig gemacht werden.",
      noDeviceModelsSharedYet: "Es wurden noch keine Gerätemodelle geteilt",
    },
    deploymentGroups: {
      label: "Deployment Groups",
      sideListTableLabel: "Depl. Groups",
      addButton: "Add Deployment Group",
      newDeploymentGroup: "Neue Deployment Group",
      updateDeploymentGroup: "Deployment Group bearbeiten",
      editModel: "Edit",
      deleteModel: "Delete",
      newDeviceType: "New Deployment Group",
      devices: "Devices",
      iotApps: "Apps",
      deployedDevicesCount: "{deployedDeviceCount} Geräte von {totalDeviceCount}",
      Apps: "Apps",
      software: "Software",
      firmware: "Firmware",
      osImage: "OS-Image",
      systemApps: "System-Apps",
      installedSoftware: "Installierte Software",
      noGroupSelected: "Keine Deployment-Gruppe ausgewählt",
      noCoreAppsInDeploymentGroup: "Es wurden noch keine Core-Apps zu dieser Deployment-Gruppe hinzugefügt.",
      noAppsInDeploymentGroup: "Es wurden noch keine Apps zu dieser Deployment-Gruppe hinzugefügt.",
      noDevicesInDeploymentGroup: "Es wurden noch keine Geräte zu dieser Deployment-Gruppe hinzugefügt.",
      groupInfo: "Gruppeninfo",
      coreApps: "System Apps",
      userName: "User Name",
      email: "Email Address",
      confirmDevicesChangesMessage: `Änderungen an den Geräten der Bereitstellungsgruppe wurden vorgenommen. Apps werden von diesen Geräten entfernt oder auf ihnen installiert, um die Konfiguration ihrer neuen Bereitstellungsgruppe widerzuspiegeln. Diese Anpassungen können Auswirkungen auf die Gerätefunktionalität und die damit verbundenen Anwendungsfälle haben. Möchten Sie trotzdem speichern?`,
      createDeploymentGroup: "Deployment Group erstellen",
      createFirstDeploymentGroup: "Erstellen Sie Ihre erste Deployment Group",
      createDeploymentGroupHelperText: "Erstellen Sie eine Deployment Group, um Ihre Geräte und Apps zu verwalten",
      noDeploymentGroupsCreatedYet: "Es wurden noch keine Deployment-Gruppen erstellt",
      addAppModal: {
        modalSteps: {
          chooseApp: "App auswählen",
          chooseImage: "Image auswählen",
          chooseFirmware: "Firmware auswählen",
          selectVersion: "Version auswählen",
          deploy: "Bereitstellen",
        },
        appAndRevisionFields: {
          firstReleaseDate: "Erstes Veröffentlichungsdatum",
          firstReleaseBy: "Erstveröffentlicht von",
          versions: "Versionen",
          currentlyInstalledOn: "Derzeit installiert auf",
        },
        noAppDetailsMessage: "Keine App Details verfügbar",
        newDeploymentTitle: "Neue Bereitstellung für {deploymentGroupName}",
        confirmDeployMessage:
          "Ich bin mir bewusst, dass diese Aktion die Funktionalität der Geräte in der ausgewählten Bereitstellungsgruppe beeinträchtigen kann.",
      },
      addOrRemoveDevices: {
        addDevices: "Geräte hinzufügen",
        availableDevices: "Verfügbare Geräte",
        addDevicesDescription:
          "Verwenden Sie die Übertragungsliste, um Geräte zu Ihrer Gruppe hinzuzufügen. Die verfügbaren Geräte sind bereits nach Typ und Modell gefiltert, um den Anforderungen Ihrer aktiven Deployment-Gruppe zu entsprechen.",
        selectDevicesMessage:
          "Wählen Sie Geräte aus der Liste auf der rechten Seite aus und klicken Sie auf den linken Pfeil, um sie zu dieser Deployment-Gruppe hinzuzufügen.",
        confirmDevicesChangesMessage: `Änderungen an den Geräten der Bereitstellungsgruppe wurden vorgenommen. Apps werden von diesen Geräten entfernt oder auf ihnen installiert, um die Konfiguration ihrer neuen Bereitstellungsgruppe widerzuspiegeln. Diese Anpassungen können Auswirkungen auf die Gerätefunktionalität und die damit verbundenen Anwendungsfälle haben. Möchten Sie trotzdem speichern?`,
      },
      adminLevel: "Admin Level",
      actions: "Actions",
      addApp: "Add application",
      removeApp: "Remove application",
      changeImage: "Image ändern",
      changeFirmware: "Firmware ändern",
      addImage: "OS-Image hinzufügen",
      addFirmware: "Firmware hinzufügen",
      removeImage: "Image entfernen",
      removeFirmware: "Firmware entfernen",
      removeImageDescription:
        "Das Entfernen des OS-Images aus der Deployment-Gruppe kann die Funktionalität der zugehörigen Geräte beeinträchtigen. Sind Sie sicher, dass Sie fortfahren möchten?",
      removeFirmwareDescription:
        "Das Entfernen der Firmware aus der Deployment-Gruppe kann die Funktionalität der zugehörigen Geräte beeinträchtigen. Sind Sie sicher, dass Sie fortfahren möchten?",
      developer: "Developer",
      developerNote: "Developer's Note",
      publisher: "Publisher",
      activeDeploymentGroup: "Aktive deployment-Gruppe",
      addDevicesDescription:
        "Verwenden Sie die Übertragungsliste, um Geräte zu Ihrer Gruppe hinzuzufügen. Die verfügbaren Geräte sind bereits nach Typ und Modell gefiltert, um den Anforderungen Ihrer aktiven Deployment-Gruppe zu entsprechen.",
      addDevicesEmptyMessage:
        "Wählen Sie Geräte aus der Liste auf der rechten Seite aus und klicken Sie auf den linken Pfeil, um sie zu dieser Deployment-Gruppe hinzuzufügen.",
      addDevicesNoneAvailableMessage: "Keine Geräte mit diesem Modell verfügbar.",
      deploymentStatus: "Deployment Status",
      deleteDeploymentGroup: {
        title: "Deployment-Gruppe löschen",
        message:
          "Sind Sie sicher, dass Sie die ausgewählte Deployment-Gruppe löschen möchten? Dies kann nicht rückgängig gemacht werden.",
        deleteErrorTitle: "Deployment-Gruppe konnte nicht gelöscht werden",
        deleteErrorHasAssinedDevicesMessage:
          "Sie können eine Deployment-Gruppe mit zugewiesenen Geräten nicht löschen. Bitte entfernen oder verschieben Sie die Geräte in eine andere Deployment-Gruppe, bevor Sie den Löschvorgang versuchen.",
      },
      removeAppTitle: "App entfernen",
      removeAppDescription:
        "Das Entfernen der App aus der Deployment-Gruppe wird sie von den zugehörigen Geräten deinstallieren, was deren Funktionalität beeinträchtigen kann. Sind Sie sicher, dass Sie fortfahren möchten?",
      created: "Created",
      edited: "Edited",
      changeVersion: {
        cancel: "Cancel",
        deploy: "Deploy",
      },
    },
    attributeFieldsAndSets: {
      label: "Attribute Fields and Sets",
      addButton: "Add Attribute",
      editModel: "Edit",
      deleteModel: "Delete",
      newDeviceType: "New Attribute",
    },
    deploymentGroupAdmins: {
      label: "Deployment Group Admins",
      transferRights: "Transfer Rights",
      admin: "Admin",
      confirmAdminChange: "Confirm Change",
      coAdmin: "Co-Admin",
      addCoAdminButton: "Add Co-Admin",
      adminChangeModalTitle: "Change deployment group admin",
      removeCoAdminModalTitle: "Remove co-admin",
      emailTextField: "Email Address",
      tryAgainButton: "Try again",
      errorGeneral: "Something went wrong",
      errorEmailTitle: "Email adress not found",
      removeCoAdminModalText: "Are you sure you want to remove this co-admin from this deployment group?",
      adminChangeModalText:
        "By designating a new admin, you will lose the ability to manage this deployment group and will retain only viewer permissions.",
      errorMessageEmail: "Please enter a valid email address of a person from your organization.",
      textMessageUpdateAdmin:
        "By designating a new admin, you will lose the ability to manage this deployment group and will retain only viewer permissions.",
      textAddCoAdmin:
        "Please provide the email address of the individual from your organization to whom you wish to grant permission to manage this deployment group. Note that this person will not have the ability to change admin settings.",
      errorMessageAddCoAdmin: "The specified user is already a co-administrator for the specified deployment group.",
      addCoAdminModalTitle: "Add co-admin",
      addCoAdminText: "New co-admin",
      addCoAdminEmailTextField: "Email Address",
      warningModal: {
        onlyDeploymentGroupAdminContent: "Only the deployment group Admin can add additional co-admins.",
      },
    },
    groups: {
      label: "Groups",
      addButton: "Add Deployment Group",
      editModel: "Edit",
      deleteModel: "Delete",
      newDeviceType: "New Deployment Group",
    },
    types: {
      label: "Types",
      addButton: "Add Deployment Groups",
      editModel: "Edit",
      deleteModel: "Delete",
      newDeviceType: "New Deployment Groups",
    },
    deviceDetails: {
      label: "Device Details",
      currentFleet: "Current Deployment Group",
      deviceNameHeader: "Device Name",
      deviceName: "Name",
      deviceType: "Type",
      deviceModel: "Model",
      deviceRevision: "Revision",
      hardwareSerialNumber: "Hardware Serial No.",
      deviceSerial: "Software Serial No.",
      storeActivity: "Last Store Activity",
      messagingActivity: "Last Messaging Activity",
      lastUptime: "Last Uptime",
      bytesSent: "bytes sent",
      installationHistory: {
        buttonLabel: "Installation history",
        title: "Installation history of {serialNumber}",
        columns: {
          dateTime: "Date & Time",
          appName: "App name",
          category: "Category",
          action: "Action",
          originalVersion: "Original version",
          targetVersion: "Target version",
          size: "Size [MB]",
        },
        categories: {
          Image: "OS Image",
          App: "App",
          Firmware: "Firmware",
        },
        changeTypes: {
          Install: "New installation",
          Upgrade: "Upgrade",
          Downgrade: "Downgrade",
          Uninstall: "Deinstallation",
          Unknown: "Unknown",
        },
      },
      logs: {
        timestamp: "Zeitstempel",
        logLevel: "Log-Level",
        signalName: "Signalname",
        message: "Nachricht",
        timeRange: "Zeitraum",
        last1Hour: "Letzte Stunde",
        last6Hours: "Letzte 6 Stunden",
        last24Hours: "Letzte 24 Stunden",
        last7Days: "Letzte 7 Tage",
      },
    },
    editDevice: {
      deviceCannotBeEdited: {
        title: "Gerät kann nicht bearbeitet werden",
        messageLineOne: "Dieses Gerät ist noch nicht aktiv.",
        messageLineTwo: "Sie können die Gerätedetails erst nach der Aktivierung bearbeiten.",
        okButton: "OK",
        cancelButton: "ABBRECHEN",
      },
      noDeviceFound: {
        title: "Kein Gerät gefunden",
        messageWithAssetId: "Kein Gerät gefunden für Asset-ID:",
        messageNoAssetId: "Keine Asset-ID angegeben",
        loadingMessage: "Lade Gerät...",
        goBackButton: "Zurück",
      },
    },
  },
};
